/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument } from './HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument';
import {
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSON,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSONTyped,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentToJSON,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentToJSONTyped,
} from './HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument';

/**
 * 
 * @export
 * @interface HchbPatientDetailsDocumentsGeneratedDocumentsInner
 */
export interface HchbPatientDetailsDocumentsGeneratedDocumentsInner {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    generated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    previous_generated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    type?: HchbPatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    instance_id?: string;
    /**
     * 
     * @type {HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument}
     * @memberof HchbPatientDetailsDocumentsGeneratedDocumentsInner
     */
    external_ehr_document?: HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument;
}


/**
 * @export
 */
export const HchbPatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum = {
    SummaryReport: 'summary_report',
    RulesReport: 'rules_report',
    DataPullsReport: 'data_pulls_report',
    SOffenderReport: 's_offender_report',
    MedicationsReport: 'medications_report',
    InsuranceEligibilityCheck: 'insurance_eligibility_check',
    AdvancedAiInsuranceCheck: 'advanced_ai_insurance_check',
    PalAuthSubmissionPackage: 'pal_auth_submission_package',
    PdpmReport: 'pdpm_report'
} as const;
export type HchbPatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum = typeof HchbPatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum[keyof typeof HchbPatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum];


/**
 * Check if a given object implements the HchbPatientDetailsDocumentsGeneratedDocumentsInner interface.
 */
export function instanceOfHchbPatientDetailsDocumentsGeneratedDocumentsInner(value: object): value is HchbPatientDetailsDocumentsGeneratedDocumentsInner {
    return true;
}

export function HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSON(json: any): HchbPatientDetailsDocumentsGeneratedDocumentsInner {
    return HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped(json, false);
}

export function HchbPatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsDocumentsGeneratedDocumentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'name': json['name'] == null ? undefined : json['name'],
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        'generated_at': json['generated_at'] == null ? undefined : json['generated_at'],
        'previous_generated_at': json['previous_generated_at'] == null ? undefined : json['previous_generated_at'],
        'type': json['type'] == null ? undefined : json['type'],
        'instance_id': json['instance_id'] == null ? undefined : json['instance_id'],
        'external_ehr_document': json['external_ehr_document'] == null ? undefined : HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSON(json['external_ehr_document']),
    };
}

export function HchbPatientDetailsDocumentsGeneratedDocumentsInnerToJSON(json: any): HchbPatientDetailsDocumentsGeneratedDocumentsInner {
    return HchbPatientDetailsDocumentsGeneratedDocumentsInnerToJSONTyped(json, false);
}

export function HchbPatientDetailsDocumentsGeneratedDocumentsInnerToJSONTyped(value?: HchbPatientDetailsDocumentsGeneratedDocumentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'name': value['name'],
        's3_key': value['s3_key'],
        'generated_at': value['generated_at'],
        'previous_generated_at': value['previous_generated_at'],
        'type': value['type'],
        'instance_id': value['instance_id'],
        'external_ehr_document': HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentToJSON(value['external_ehr_document']),
    };
}

